import { removeSession } from '@/shared/application/services';

import * as S from './Logout.style';
import { SidebarDivisor } from '../Sidebar.styles';

export const SidebarLogout = ({ render }: any): JSX.Element | null => {
  // eslint-disable-next-line no-extra-boolean-cast
  if (!!render) return render;

  return (
    <S.Logout>
      <SidebarDivisor />

      <S.UserLoggoutButton type="button" onClick={() => removeSession()}>
        Sair
      </S.UserLoggoutButton>
    </S.Logout>
  );
};
